import { Box, Button, Container } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { VdsPageTitle, VdsTextField } from "../../@vds";
import { useLoaderContext, useWarningNotify } from "../../contexts";
import { AddClient, GetUserProfile, GetUserProfileResponse } from "../../helpers/api.helpers";

export type PromoLocationState = GetUserProfileResponse & {
    POC_HR_Token?: string,
    POC_HR_CampaignOid?: string
};

export const HomePage = () => {

    const navigate = useNavigate();
    const setLoader = useLoaderContext();
    const warning = useWarningNotify();

    const [company, setCompany] = React.useState({ vatCode: '' });

    const handleClick = React.useCallback(() => {

        setLoader(true);
        AddClient({
            vatCode: company.vatCode
        }).then((addClientResponse) => {

            if (addClientResponse.data.commands.length) {

                GetUserProfile({
                    vatCode: company.vatCode
                }).then((getUserProfileResponse) => {

                    setLoader(false);

                    const firstCommand = addClientResponse.data.commands[0];
                    const POC_HR_Token = firstCommand.parameters.find(({ key }) => key === "PromoToken")?.value;
                    const POC_HR_CampaignOid = firstCommand.parameters.find(({ key }) => key === "CampaignId")?.value;

                    const state: PromoLocationState = {
                        ...getUserProfileResponse.data,
                        POC_HR_Token,
                        POC_HR_CampaignOid
                    };

                    navigate("promo", {
                        state
                    });
                }).catch((res) => {
                    const code = res?.response?.status || 500;
                    setLoader(false);
                    navigate(`/errors`, { state: { code } });
                })
            } else {

                setLoader(false);
                warning("Inserire un'altra partita IVA");
            }
        }).catch((res) => {
            const code = res?.response?.status || 500;
            setLoader(false);
            navigate(`/errors`, { state: { code } });
        })
    }, [setLoader, company.vatCode, navigate, warning]);

    const handleVatCodeChange: React.ChangeEventHandler<HTMLInputElement> = React.useCallback((ev) => {
        const value = ev.target.value;
        setCompany({ ...company, vatCode: value });
    }, [company]);

    return (
        <Container maxWidth="sm" sx={{ height: 'calc(100vh - 100px)', overflow: 'auto' }} >
            <VdsPageTitle
                title="Lorem ipsum"
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
            />
            <Box display="flex" gap={1} alignItems="flex-end">
                <Box flexGrow="1">
                    <VdsTextField
                        label="Partita IVA"
                        value={company.vatCode}
                        error={!company.vatCode}
                        onChange={handleVatCodeChange}
                        fullWidth
                        collapse
                    />
                </Box>
                <Box sx={{ mb: '2px' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!company.vatCode}
                        onClick={handleClick}
                    >
                        Continua
                    </Button>
                </Box>
            </Box>
        </Container>
    );
};
